<template>
  <div class="leadingin">
    <div class="leadingin_top">
      <el-form ref="form" :model="form" label-position="left" label-width="110px" :rules="rules" size="small">
        <el-form-item label="计划开始时间:" prop="dateTime">
          <el-date-picker
            v-model="form.dateTime"
            type="date"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="leadinginLeft">
        <ul>
          <li v-for="(item, index) in list" :key="index" :class="[item.packageId === cur ? 'active' : '']"
            :title="item.packageName" @click="clickLi(item)">
            {{ item.packageName }}
          </li>
        </ul>
      </div>
      <div class="leadinginRight">
        <div class="table">
          <el-table ref="multipleTable" :data="tableData" :tree-props="{ children: 'nodeList' }" style="width: 100%"
            highlight-current-row row-key="taskId" default-expand-all border>
            <el-table-column prop="taskName" label="名称" align="center" />
            <el-table-column prop="planSchedule" label="工期" align="center" show-overflow-tooltip />
            <el-table-column prop="originalSpecName" label="专业" align="center" show-overflow-tooltip />
            <el-table-column prop="flowTempName" label="关联流程" align="center" show-overflow-tooltip />
            <el-table-column prop="preTaskName" label="紧前计划" align="center" show-overflow-tooltip />
            <el-table-column prop="afterTaskName" label="紧后计划" align="center" show-overflow-tooltip />
            <el-table-column prop="isMilestone" label="里程碑" align="center" show-overflow-tooltip>
              <template #default="{ row }">
                <span>{{ ["否", "是"][row.isMilestone] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import taskPackageservice from "@/CommonDP/service/taskPackage-service";
import { mapState } from "vuex";
export default {
  data() {
    return {
      list: [],
      tableData: [],
      cur: "",
      icon1: require("@/CommonDP/assets/settings/里程碑.png"),
      form: {
        dateTime: ''
      },
      rules: {
        dateTime: [{ required: true, trigger: "change", message: '请选择计划开始时间' }]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.getList();
  },
  methods: {
    clickLi(item) {
      this.cur = item.packageId;
      this.taskpackagelist();
    },
    // 计划包分类list
    getList() {
      taskPackageservice.taskpackagetypelist(this.enterpriseId).then((res) => {
        this.list = res.data;
        this.cur = res.data[0].packageId;
        this.taskpackagelist();
      });
    },
    taskpackagelist() {
      var data = {
        packageId: this.cur,
        taskName: ""
      };
      taskPackageservice.taskpackagelist(data).then((res) => {
        this.tableData = res.data;
      });
    },
    async validateFormData() {
      return await this.validate();
    },
    async validate() {
      try {
        return await this.$refs.form.validate();
      } catch (e) {
        // 校验失败
        return false;
      }
    },
    taskPackage() {
      return { id: this.cur, dateTime: this.form.dateTime };
    }

  }
};
</script>

<style lang="scss" scoped>
.leadingin {
  background: #fff;
  border-radius: 4px;
  height: 600px;
  overflow: auto;
  .leadingin_top{
    border-bottom: 1px solid #dae0ec;
    padding: 13px 10px 0 10px;
    .el-form {
      width: 100%;
      /deep/ .el-form-item {
        margin-bottom: 0px !important;
        .el-form-item__content{
          .el-form-item__error{
            top: 34px;
          }
        }
      }
    }
  }
  .leadinginLeft {
    display: inline-block;
    border-right: 1px solid #dae0ec;
    width: 188px;
    height: 517px;
    overflow-y: auto;
    ul {
      margin-top: 20px;
      li {
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        padding-left: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 186px;
      }
      .active {
        background: #ecf5ff;
      }
    }
  }
  .leadinginRight {
    display: inline-block;
    vertical-align: top;
    width: 82%;
    margin-left: 10px;
    .table {
      margin-top: 15px;
      padding: 0px 0px;
      /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #f7f9ff;
      }
      ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
        td:first-child {
          padding-left: 23px;
        }
      }
    }
  }
}
</style>
